import React from 'react';
import { format } from 'date-fns';
import { graphql } from 'gatsby';
import { Feed } from '../feed/Feed';

const BlogFeed = ({ data: { posts } }) => {
  const items = posts?.nodes?.map((item) => ({
    heading: item?.name,
    metaDetail: format(new Date(item?.publishDate), 'dd/MM/yyyy'),
    url: item?.url,
    label: 'Read more',
    id: item?.id,
    image: item?.properties?.feed?.featuredImage?.image?.localFile,
    item,
  }));

  return <Feed items={items} />;
};

export default BlogFeed;

export const query = graphql`
  query BlogFeedQuery($numberOfPosts: Int) {
    posts: allUmbracoBlogArticleType(
      limit: $numberOfPosts
      sort: { publishDate: ASC }
    ) {
      nodes {
        ...BlogArticleCard
      }
    }
  }
`;
